import { Button, Descriptions, Popconfirm, Row, Space } from 'antd';
import { corporateNumberFormatter } from '../../util/utils';

interface TaxInvoiceAccountDetailComponentProps {
  taxInvoiceAccount: any;
  onUpdate: () => void;
  onDelete: () => void;
}

function TaxInvoiceAccountDetailComponent({
  taxInvoiceAccount,
  onUpdate,
  onDelete,
}: TaxInvoiceAccountDetailComponentProps) {
  return (
    <>
      <Row justify={'end'} style={{ marginTop: '0px', marginBottom: '0px' }}>
        <Space>
          <Button size="small" onClick={onUpdate}>
            수정
          </Button>
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              onConfirm={() => onDelete()}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      </Row>
      <Descriptions
        title="홈택스계정"
        bordered
        column={2}
        size="small"
        style={{ marginTop: '10px' }}
      >
        <Descriptions.Item label="아이디">
          {taxInvoiceAccount.userName}
        </Descriptions.Item>
        <Descriptions.Item label="사업자번호">
          {corporateNumberFormatter(
            taxInvoiceAccount.enterprise.corporateNumber,
          )}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        title="담당자"
        bordered
        column={2}
        size="small"
        style={{ marginTop: '30px' }}
      >
        <Descriptions.Item label="이름">
          {taxInvoiceAccount.user.name}
        </Descriptions.Item>
        <Descriptions.Item label="이메일">
          {taxInvoiceAccount.user.email}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        title="기타정보"
        bordered
        column={2}
        size="small"
        style={{ marginTop: '30px' }}
      >
        <Descriptions.Item label="사용방식">
          {taxInvoiceAccount.type === '0'
            ? '홈택스 자료로 매입증빙 하기'
            : '홈택스 자료로 지출등록하기'}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
}

export default TaxInvoiceAccountDetailComponent;
